import { NEKOSEI_PET_CAT_COUNT } from "@/domains/nekosei/NekoseiBirth";

const MAN = 10_000;
const SEN = 1_000;

/** 8847000 → 「884万7000」 */
const toManNotation = (count: number): string => {
  const rest = count % MAN;
  return `${Math.floor(count / MAN)}万${rest === 0 ? "" : rest}`;
};

/** 8847000 → 「884万7千」。文中で「約〜匹」と言うときに使う */
const toApproximateManNotation = (count: number): string => {
  const sen = Math.round((count % MAN) / SEN);
  return `${Math.floor(count / MAN)}万${sen === 0 ? "" : `${sen}千`}`;
};

/** 日本で飼われている猫のうちの1匹として生まれる、という意味のゲーム名 */
export const NEKOSEI_GAME_NAME = `${toManNotation(NEKOSEI_PET_CAT_COUNT)}分の1`;

export const NEKOSEI_GAME_SUBTITLE = "名前はまだ無い";

export const NEKOSEI_GAME_FULL_NAME = `${NEKOSEI_GAME_NAME}（${NEKOSEI_GAME_SUBTITLE}）`;

export const NEKOSEI_PET_CAT_COUNT_LABEL = `約${toApproximateManNotation(NEKOSEI_PET_CAT_COUNT)}匹`;
